import React, { ComponentProps } from "react";

interface XIconProps extends ComponentProps<"svg"> {
  strokeColor?: string;
  bgColor?: string;
}

export default function XIcon({ strokeColor, bgColor, ...props }: XIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      {...props}
    >
      <circle cx="15" cy="15" r="15" fill={bgColor ?? "#EEEBFF"} />
      <path
        d="M10.213 10.2108L19.7913 19.7891"
        stroke={strokeColor ?? "#6C53E8"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7934 10.2069L10.2052 19.7951"
        stroke={strokeColor ?? "#6C53E8"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
